interface LandingPageProps {
  onSelectSmartContract: () => void;
  onSelectWebPentest: () => void;
}

const SECURITY_TOOL_LOGOS = [
  {
    name: 'Trail of Bits',
    src: '/trail_of_bits_logo.jpg'
  },
  {
    name: 'Cyfrin',
    src: '/cyfrin.jpg'
  },
  {
    name: 'Pashov',
    src: '/pashovlogo.png'
  },
  {
    name: 'QuillShield',
    src: '/quillshield.avif'
  }
];

function ShieldCheckIcon() {
  return (
    <svg className="audit-choice-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        d="M12 3.5 19 6v5.3c0 4.5-2.8 8.3-7 9.2-4.2-.9-7-4.7-7-9.2V6l7-2.5Z"
        fill="none"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.8"
      />
      <path
        d="m8.8 12.2 2.1 2.1 4.4-5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
      />
    </svg>
  );
}

function GlobeIcon() {
  return (
    <svg className="audit-choice-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M3.8 9h16.4M3.8 15h16.4M12 3.2c2 2.3 3 5.2 3 8.8s-1 6.5-3 8.8c-2-2.3-3-5.2-3-8.8s1-6.5 3-8.8Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
      />
    </svg>
  );
}

function ArrowRightIcon() {
  return (
    <svg className="audit-choice-arrow" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        d="M5 12h14M13 6l6 6-6 6"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
}

function LandingPage({ onSelectSmartContract, onSelectWebPentest }: LandingPageProps) {
  return (
    <main className="landing-page" aria-labelledby="landing-title">
      <section className="landing-copy-panel">
        <a className="landing-brand" href="/" aria-label="Havu home">
          <img className="landing-brand-mark" src="/logoinvert.png" alt="" aria-hidden="true" />
          <span>Havu</span>
        </a>

        <div className="landing-copy">
          <h1 id="landing-title">Havu AI Orchestrator</h1>
          <p>
            Run Fable, Gpt 5.6, and all other frontier security agents against your codebase and receive a structured pentest report with aggregated findings ready for investors.
          </p>
        </div>

        <div className="landing-meta">
          <section className="security-tool-strip" aria-labelledby="security-tool-title">
            <h2 id="security-tool-title">Powered by trusted security tools</h2>
            <div className="security-tool-row" aria-label="Supported security tools">
              {SECURITY_TOOL_LOGOS.map((tool) => (
                <span className="security-tool-logo" key={tool.name}>
                  <img src={tool.src} alt={tool.name} loading="lazy" />
                  <span>{tool.name}</span>
                </span>
              ))}
            </div>
          </section>

          <div className="landing-affiliations" aria-label="Havu affiliations">
            <span className="landing-affiliation-item">
              <img src="/scauditstudiologo.png" alt="" aria-hidden="true" />
              <span>Developed by SC Audit Studio</span>
            </span>
            <a
              className="landing-affiliation-item"
              href="https://partners.circle.com/partner/sc-audit-studio"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/circlelogo.png" alt="" aria-hidden="true" />
              <span>Member of Circle alliance</span>
            </a>
          </div>
        </div>
      </section>

      <aside className="audit-entry-panel" aria-label="Choose an audit workflow">
        <div className="audit-entry-copy">
          <h2>Security workflows</h2>
        </div>

        <div className="audit-choice-stack">
          <button type="button" className="audit-choice-button primary" onClick={onSelectWebPentest}>
            <GlobeIcon />
            <span>Web and API pentest</span>
            
            <ArrowRightIcon />
          </button>

          <button
            type="button"
            className="audit-choice-button secondary"
            onClick={onSelectSmartContract}
          >
            <ShieldCheckIcon />
            <span>Smart contract audit</span>
            <ArrowRightIcon />
          </button>
        </div>
      </aside>
    </main>
  );
}

export default LandingPage;
